import type { ReactNode } from 'react'

import { Flex, Heading } from 'app/ui'

import { joinStyles } from 'app/utils/theme'

import { GroupHeaderPage } from 'app/types/app/headerPage'
import * as styles from './HeaderPage.css'

type HeaderPageProperties = {
    group: GroupHeaderPage
    icon: ReactNode
    title: string
    buttons?: ReactNode[]
    filters?: ReactNode[]
}

/** Header to inform and filter data. */
export const HeaderPage = ({
    group,
    icon,
    title,
    buttons,
    filters,
}: Readonly<HeaderPageProperties>): JSX.Element => {
    return (
        <div className={joinStyles(styles.root, styles.group[group])}>
            <Flex className={styles.titleGroup}>
                {/* Title */}
                <Heading className={styles.title}>
                    <div className={styles.titleIcon}>{icon}</div>

                    {title}
                </Heading>

                {/* Buttons */}
                {!!buttons && buttons.length > 0 && <Flex>{buttons}</Flex>}
            </Flex>

            {/* Filters */}
            {!!filters && filters.length > 0 && (
                <Flex className={styles.filterGroup}>{filters}</Flex>
            )}
        </div>
    )
}
